module.exports = __webpack_public_path__ + "static/sisa-805af93261222e0a1c1322a9d84a3ccb.png";